import { FC } from "react";
import { Button } from "@/components/ui/button";
import { Bold, Italic, Smile, ShoppingBag, ThumbsUp, Heart, Star } from "lucide-react";

interface MessageTemplateButtonsProps {
  onFormatText: (format: "bold" | "italic") => void;
  onInsertEmoji: (emoji: string) => void;
}

export const MessageTemplateButtons: FC<MessageTemplateButtonsProps> = ({
  onFormatText,
  onInsertEmoji,
}) => {
  return (
    <div className="flex gap-2 mt-2">
      <Button
        type="button"
        variant="outline"
        size="icon"
        onClick={() => onFormatText("bold")}
        className="bg-white dark:bg-[#1F2C34] hover:bg-[#F0F2F5] dark:hover:bg-[#2A3942] border-[#25D366] dark:border-[#00A884]"
      >
        <Bold className="h-4 w-4" />
      </Button>
      <Button
        type="button"
        variant="outline"
        size="icon"
        onClick={() => onFormatText("italic")}
        className="bg-white dark:bg-[#1F2C34] hover:bg-[#F0F2F5] dark:hover:bg-[#2A3942] border-[#25D366] dark:border-[#00A884]"
      >
        <Italic className="h-4 w-4" />
      </Button>
      <Button
        type="button"
        variant="outline"
        size="icon"
        onClick={() => onInsertEmoji("👋")}
        className="bg-white dark:bg-[#1F2C34] hover:bg-[#F0F2F5] dark:hover:bg-[#2A3942] border-[#25D366] dark:border-[#00A884]"
      >
        <Smile className="h-4 w-4" />
      </Button>
      <Button
        type="button"
        variant="outline"
        size="icon"
        onClick={() => onInsertEmoji("🛍️")}
        className="bg-white dark:bg-[#1F2C34] hover:bg-[#F0F2F5] dark:hover:bg-[#2A3942] border-[#25D366] dark:border-[#00A884]"
      >
        <ShoppingBag className="h-4 w-4" />
      </Button>
      <Button
        type="button"
        variant="outline"
        size="icon"
        onClick={() => onInsertEmoji("👍")}
        className="bg-white dark:bg-[#1F2C34] hover:bg-[#F0F2F5] dark:hover:bg-[#2A3942] border-[#25D366] dark:border-[#00A884]"
      >
        <ThumbsUp className="h-4 w-4" />
      </Button>
      <Button
        type="button"
        variant="outline"
        size="icon"
        onClick={() => onInsertEmoji("❤️")}
        className="bg-white dark:bg-[#1F2C34] hover:bg-[#F0F2F5] dark:hover:bg-[#2A3942] border-[#25D366] dark:border-[#00A884]"
      >
        <Heart className="h-4 w-4" />
      </Button>
      <Button
        type="button"
        variant="outline"
        size="icon"
        onClick={() => onInsertEmoji("⭐")}
        className="bg-white dark:bg-[#1F2C34] hover:bg-[#F0F2F5] dark:hover:bg-[#2A3942] border-[#25D366] dark:border-[#00A884]"
      >
        <Star className="h-4 w-4" />
      </Button>
    </div>
  );
};